module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-MT4BK23","includeInDevelopment":false,"enableWebVitalsTracking":true,"selfHostedOrigin":"https://suacausa.com","selfHostedPath":"metrics","defaultDataLayer":null,"routeChangeEventName":"gatsby-route-change"},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"SuaCausa.com","short_name":"SuaCausa.com","description":"Sua Causa: Modelos estruturados de peças processuais e prática forense para estágio supervisionado de Direito.","start_url":"/","background_color":"#fff","display":"standalone","icon":"static/sites/suacausa/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"caa946e76e9967ad1174385401b5b92d"},
    },{
      plugin: require('../node_modules/gatsby-plugin-next-seo/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.ts'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
